import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CookieService } from '../Services/cookie';



@Component({
  selector: "app-pay-card-suspended",
  templateUrl: "./pay-card-suspended.component.html",
  standalone:false,
  styleUrls: ["./pay-card-suspended.component.scss"],
})
export class PayCardSuspendedComponent implements OnInit {
  Screen: any;
  constructor(private router:Router,private cookieService: CookieService,) { }

  async ngOnInit(): Promise<any> {
    let S = await this.cookieService.get("Screen",false);
    if(S){
      this.Screen = S;
    }}
}

